
import { FLUTTER_IFRAME_WRAPPER_MAP } from './../../flutter/flutter.consts.js';
import { resizeFrame, isDesktop, parseJSONRecursively, isLikelyJSON, addLoadingSpinner, removeLoadingSpinner, sendToGa4 } from './../../flutter/flutter.utils.js';
// FlutterGiftVoucher.js
export default class FlutterGiftVoucher {

  constructor() {
    if (process.env.NODE_ENV === 'development') {
      console.log('flutter.vouchers: initializing');
    }
    this.loadDependencies().then(() => {
      this.initializeProperties();
      if (this.$wrapper.length >= 1) {
        addLoadingSpinner(this.$wrapper);
      }
      if (this.debugMode) {
        console.log('flutter.vouchers: initialized');
      }
    });
  }

  // loadDependencies - Loads the dependencies for the widget
  // @returns {Promise} - The promise that resolves when the dependencies are loaded
  async loadDependencies() {
    await Promise.all([
      import(/* webpackMode: "eager" */ './flutter-gift-voucher.scss'),
    ]);
  }

  // initializeProperties - Initializes the properties for the widget
  initializeProperties() {
    this.$wrapper = $(FLUTTER_IFRAME_WRAPPER_MAP['vouchers'])
    this.$confirmationArea = $('.gift-voucher-confirmation-widget-area')
    this.confirmationWidgetSize = 360;

    // Resizing
    this.$window = $(window);
    this.minHeightDesktop = 0;   // Desktop height so that the calendars always are visible
    this.minHeightMobile = 0;    // Desktop height so that the calendars always are visible
    this.mobileBreakpoint = 0;   // The width at which the flutter widget swaps from desktop to to mobile
    this.heightBuffer = 30;        // height buffer underneath the widget

    this.localDebugEnabled = false;
    this.debugMode == this.localDebugEnabled && process.env.NODE_ENV === 'development';

  }

  // handleEvent - Handles the event from the iframe
  // @param {string} eventType - The event type
  // @param {object} eventData - The event data
  // @returns {void}
  handleEvent(eventType, eventData) {
    const self = this;
    if (self.debugMode) {
      console.log('flutter.vouchers: received event', eventType, eventData);
    }
    removeLoadingSpinner(this.$wrapper)
    switch (eventType) {
      case 'onAppStarted':
        removeLoadingSpinner(this.$wrapper)
        break;
      case 'ga4Event':
       sendToGa4(eventData);
        break;
      case 'onResize':
        resizeFrame(
          this.$wrapper,
          eventData.width,
          eventData.height,
          (isDesktop()) ? this.minHeightDesktop : this.minHeightMobile,
          this.heightBuffer
        );
        break;
      case 'summary':
      case 'submitted':
        this.handleSummaryEvent(eventData);
        break;
      case 'error_submitting_form':

        break;
        case 'redirect':
          this.handleRedirection(eventData);
          break;
      default:
        if (self.debugMode) {
          debugger;
        }
        console.warn('flutter.giftvoucher: Unhandled Flutter Event' + eventType, eventData);
        break;
    }
  }
    handleRedirection = (eventData) => {

    let targetUrl = window.location.origin + eventData;
    if (window.top) {
      window.top.open(targetUrl, '_blank');
    } else {
      window.open(targetUrl, '_blank');
    }
    // TODO improve the redirect logic to handle eventData.location
  }

  // handleErrorEvent - Handles the error event from the iframe
  // @param {object} eventData - The event data
  // @returns {void}
  // This function is called when the user has submitted the form and an error has occurred
  handleErrorEvent = (eventData) => {
    const self = this;
    if (self.debugMode) {
      console.error('flutter.giftvoucher: handleErrorEvent', eventData);
      debugger;
    }
  }

  // handleSummaryEvent - Handles the summary event from the iframe
  // @param {object} eventData - The event data
  // @returns {void}
  // This function is called when the user has submitted the form and the summary page is displayed
  handleSummaryEvent = (eventData) => {
    const self = this;
    if (self.debugMode) {
      console.log('flutter.giftvoucher: handleSummaryEvent', eventData);
    }
    console.log('hide top content');
    $('.main-content .top-content').hide();
    // Scroll the page to show the flutter_gift_voucher_widget confirmation page
    // Display the confirmation widget area
    let flutterGiftVoucherWidgetPosition = this.$wrapper.offset().top - 120;
    $('html, body').animate({
      scrollTop: flutterGiftVoucherWidgetPosition
    }, 500);
    console.log('triggered scroll to top');
    this.$confirmationArea.fadeIn(250).show();
    console.log('display confirmation area');
    this.$wrapper.height(this.confirmationWidgetSize)
    this.$wrapper.children('iframe').height(this.confirmationWidgetSize)
  }
}
